import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  EditButton,
  DeleteButton,
  DateField,
  usePermissions,
} from 'react-admin';
import ListActions from '../../components/ListActions';
import ClientsFilter from '../../components/ClientsFilter';
import TourClients from './TourClients';

const ClientsList = (props) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  return (
    <List
      {...props}
      sort={{ field: 'updatedAt', order: 'DESC' }}
      actions={
        <ListActions
          {...props}
          tourConfig={TourClients({ translate })}
          hideFilters
        />
      }
      bulkActionButtons={permissions === 'ADMIN'}
      filters={<ClientsFilter />}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" label={translate('custom.general.name')} />
        <TextField source="theme" label={translate('custom.clients.theme')} />
        <TextField
          label={translate('custom.clients.coursesLength')}
          source="courses.length"
        />
        <DateField
          label={translate('custom.general.createdAt')}
          source="createdAt"
          showTime
        />
        <DateField
          label={translate('custom.general.updatedAt')}
          source="updatedAt"
          showTime
        />
        <EditButton data-testid="clients-edit" />
        {permissions === 'ADMIN' && (
          <DeleteButton data-testid="clients-delete" />
        )}
      </Datagrid>
    </List>
  );
};

export default ClientsList;
